import {reactive} from "vue";
import info from "@/info";
import localization from "@/localization";
import notifications from "@/systems/notifications/notifications";

export default reactive({
  initialized: false,
  async initialize() {
    await info.initialize();
    if (localization.browserLanguage() && !info.global.language) {
      await localization.updateSessionLanguage(localization.browserLanguage());
    }
    await localization.reloadTranslations();
    notifications.initialize();
    this.initialized = true;
  }
});